import { Divider, Modal } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { AddSignatureModalBody } from './AddSignatureModalBody';

interface Props {
	opened: boolean;
	onClose: () => void;
	onConfirm: (imageUrl: string) => void;
}

export const AddSignatureModal = ({ opened, onClose, onConfirm }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title={tCommonUi('add_signature_modal.title', { defaultValue: 'Add signature' })}
			size="xl"
			centered
		>
			<Divider mb="1rem" />
			{opened && <AddSignatureModalBody onConfirm={onConfirm} onClose={onClose} />}
		</Modal>
	);
};
